import React from 'react';
// import photo from '../../../../assets/images/Photo.png';
import '../Landing.css';

import { ListItemIcon, Grid, List, ListItem, ListItemText, Divider } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
// import FormatQuote from '@material-ui/icons/FormatQuote';
import definitionSection from '../styles/definitionStyles';
import Rocket from '../../../../assets/icons/ReactSvg/Rocket';
import Dartboard from '../../../../assets/icons/ReactSvg/Dartboard';

const hexToRgb = (input) => {
  input = input + '';
  input = input.replace('#', '');
  let hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error('input is not a valid hex color.');
  }
  if (input.length === 3) {
    let first = input[0];
    let second = input[1];
    let last = input[2];
    input = first + first + second + second + last + last;
  }
  input = input.toUpperCase(input);
  let first = input[0] + input[1];
  let second = input[2] + input[3];
  let last = input[4] + input[5];
  return parseInt(first, 16) + ', ' + parseInt(second, 16) + ', ' + parseInt(last, 16);
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  media: {
    height: 140,
  },
  mediaHeader: {
    // margin: "-50px auto 0",
    padding: '0',
    overflow: 'hidden',
    // maxWidth: "100px",
    boxShadow:
      '0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
    // maxHeight: "100px",
    borderRadius: '50%',
    width: '200px',
    height: '200px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '@media (min-width: 576px)': {
      // position: "inherit",
      margin: '0 auto',
      transform: 'none',
      position: 'unset',
    },
    '@media (max-width: 830px)': {
      margin: '0 auto',
      transform: 'none',
      position: 'unset',
    },
  },
  img: {
    width: '100px',
    height: '100px',
  },
  reletive: {
    position: 'relative',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  headingNormal: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightRegular,
  },
  pageHeader: {
    position: 'relative',
    height: '100vh',
    maxHeight: '1600px',
    backgroundPosition: '50%',
    backgroundSize: 'cover',
    margin: '0',
    padding: '0',
    border: '0',
    display: 'flex',
    WebkitBoxAlign: 'center',
    MsFlexAlign: 'center',
    alignItems: 'center',
    '&:before': {
      background: 'rgba(' + hexToRgb('#000') + ', 0.5)',
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''",
    },
  },
  cardTitle: {
    color: '#283f71',
  },
}));

const Definition = (props) => {
  const { classes } = props;
  const expClasses = useStyles();
  return (
    // Definition
    <div className={classes.definitions}>
      <div className={classes.container}>
        {/* <Grid container spacing={0} justify="center"> */}
        {/* <Grid item xs={12} sm={12} md={10}> */}
        {/* <Box boxShadow={3}> */}
        {/* <Card > */}
        {/* <CardAvatar testimonial>
                      <img src={photo} alt="..." />
                    </CardAvatar> */}

        {/* <Grid item xs={12} sm={12} md={3} className={expClasses.reletive}> */}
        {/* <CardMedia
                            className={expClasses.mediaHeader}
                            image={photo}
                        /> */}
        {/* </Grid> */}

        {/* <Grid item xs={12} sm={12} md={7} className={classes.card1}> */}
        {/* <CardHeader> */}

        {/* </CardHeader> */}
        {/* <div className={classes.icon}>
                            <FormatQuote style={{ color: '#283f71', transform: "rotate(180deg)" }} />
                        </div> */}

        {/* <CardContent >
                            <p className={classes.cardDescription}>«Своєчасність надання соціальної допомоги є надважливою для уникнення  потрапляння дітей в інтернати, розпаду сімей, накопичення боргів за комунальні послуги, для вчасного отримання догляду за різними категоріями населення. Але якщо за послугою варто по кілька разів їхати за десятки кілометрів зі стосом документів - тоді її важко назвати доступною. Наша мета - щоб кожен, засвідчивши свою особу та з мінімальним переліком документів, міг звернутись до провайдера надання соціальної послуги в межах 10 км від місця проживання та у відповідні терміни отримати її»</p>

                            <div className={classes.icon} style={{ float: "right" }}>
                                <FormatQuote style={{ color: '#283f71' }} />
                            </div>
                            <h4 className={expClasses.cardTitle}>Юлія Соколовська</h4>
                            <h6 className={classes.cardCategory}>Міністр соціальної політики</h6>
                        </CardContent> */}

        {/* </Grid> */}

        {/* </Card> */}
        {/* </Box> */}
        {/* </Grid> */}
        {/* </Grid> */}
        {/* </Grid> */}

        {/* <img src={photo} alt="face" className="photo" width="200" /> */}

        <Grid container justify="center">
          <Grid item xs={12} sm={12} md={12} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <h2 className={classes.title}>
              Що таке програмний комплекс <br></br>«Інтегрована інформаційна система «Соціальна громада»?
            </h2>
          </Grid>
          <Grid item xs={12} sm={12} md={12} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <p>
              Програмний комплекс «Інтегрована інформаційна система «Соціальна громада» (ПК «ІІС «Соціальна громада») —
              це клієнт-серверний WEB-додаток, який розроблено з метою наближення адміністративних послуг соціального
              характеру до мешканців територіальних громад (далі - ТГ).
            </p>
          </Grid>

          <Grid item xs={12} sm={12} md={12} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <p>
              ПК «ІІС «Соціальна громада» об’єднує у єдиному інформаційному середовищі «фронт»-офіси прийому документів
              від населення, що знаходяться, приміром, у ЦНАП з «бек»-офісом у структурних підрозділах соціального
              захисту населення (далі - СПСЗН) райдержадміністрації, де приймається рішення про надання адміністративної
              послуги соціального характеру. Це, у свою чергу:
            </p>
            <List>
              <ListItem>
                <ListItemIcon>
                  <Rocket />
                </ListItemIcon>
                <ListItemText secondary="Пришвидшує отримання адміністративних послуг соціального характеру майже на тиждень, адже раніше органи місцевого самоврядування (далі - ОМС) в середньому раз на 7 днів  доставляли прийняті документи від населення до СПСЗН. ПК «ІІС «Соціальна громада» того ж дня дасть змогу  передавати в «бек»-офіс прийняті електронні копії документів." />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText secondary="*З метою формування паперових особових справ одержувачів усіх видів соціальних допомог паперові документи передаються з «фронт»-офісу до СПСЗН не рідше ніж 1 раз на 2 тижні." />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemIcon>
                  <Dartboard />
                </ListItemIcon>
                <ListItemText secondary="Наближує послуги до мешканців ТГ через мережу «фронт» - офісів." />
              </ListItem>
            </List>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}
          ></Grid>
        </Grid>
        {/* </Grid> */}
      </div>
    </div>
  );
};

export default withStyles(definitionSection)(Definition);
